(function() {
  'use strict';
  angular.module('ringbaPortal').directive('trCampaigns', trCampaigns);

  function trCampaigns() {
    const directive = {
      restrict: 'E',
      scope: {},
      controller: 'CampaignsController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/campaigns/campaigns.view.html'
    };
    return directive;
  }
})();
